import React, { Component } from 'react';
import TopBox from './TopBox';
import { Dropdown, Button, Select, Progress } from 'antd';
import { getTopMenuWidth, getTopMenu } from '../../services/helper/topMenuHelper';
import './index.css';
import { SPLIT_LINE } from '../../services/Rocky/helper/topMenuHelper';
import { PROJECT_V2 } from '../../constants/projectVersion';
import { CASCADE } from '../../constants/pageType';

class ResultTopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList: [],
      totalWidth: null,
      downloadProgress: -1,
    }
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const { product, menu, isSweep, rightMenuWidth, backSetup, isStatEye, projectVersion, isAds } = this.props;
    const _menu = getTopMenu(menu, "result-top-menu-id", product, { isSweep, rightMenuWidth, backSetup });
    this.setState({
      menuList: isStatEye || isAds ? projectVersion === PROJECT_V2 ? _menu : _menu.filter(item => item.name !== "Waveform" && item.key !== "margins") : _menu
    })
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resize);
    this.resize();
    const ele = document.getElementById("result-top-menu-id");
    const totalWidth = ele ? ele.offsetWidth : null;
    this.setState({
      totalWidth
    });
    const { menu = [], selectedKey } = this.props;
    const isExistSelect = menu.find(item => item.key === selectedKey);
    if (!isExistSelect && menu[0]) {
      this.props.changeResultType(menu[0].key)
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { menu, isCLK, rightMenuWidth, isStatEye, resultPageType, isAds } = this.props;

    const ele = document.getElementById("result-top-menu-id");
    const totalWidth = ele ? ele.offsetWidth : null;
    if (totalWidth !== prevState.totalWidth || prevProps.menu.length !== menu.length || prevProps.isCLK !== isCLK || rightMenuWidth !== prevProps.rightMenuWidth || prevProps.isStatEye !== isStatEye
      || prevProps.resultPageType !== resultPageType || prevProps.isAds !== isAds) {
      this.setState({
        totalWidth
      });
      this.resize();
    }
  }

  subMenu = (children) => {
    return children.map(it => ({ key: it.key, label: it.name, className: this.props.selectedKey === it.key ? "ant-menu-item-selected" : "" }))
  }

  handleClick = async () => {
    this.setState({ downloadProgress: 0 });
    const interval = setInterval(() => {
      this.setState((s) => {
        if (s.downloadProgress < 90) return { downloadProgress: s.downloadProgress += Math.floor(Math.random() * 10 + 1) };
        return s;
      });
    }, 100);
    try {
      await this.props.downloadClick();
    } finally {
      clearInterval(interval);
      this.setState({ downloadProgress: 100 });
      setTimeout(() => this.setState({ downloadProgress: -1 }), 1000);
    }
  };

  render = () => {
    const { selectedKey, changeResultType, children, backSetup, selectDataList, verificationId, selectedChildren, selectItem, product } = this.props;
    const { menuList, downloadProgress } = this.state;
    const menuWidth = getTopMenuWidth(menuList);
    return (
      <TopBox>
        <div className={`result-top-menu-content ${product === CASCADE ? 'result-top-menu-flex-content' : ''}`}>
          {backSetup ?
            <div className='result-top-menu-item result-top-menu-setup'>
              <span
                title="Back to setup"
                key={backSetup.key}
                className={selectedKey === backSetup.key ? "menu-item-title menu-item-title-select" : "menu-item-title menu-item-back-setup"}
                onClick={(e) => changeResultType(backSetup.key)}
              >
                <span className="menu-item-title-icon">&lt;</span>
                <span className="menu-item-title-span">{backSetup.name}</span>
              </span>
              <span className='aurora-top-bar-vertical-line'></span>
            </div> : null}
          {selectItem ? selectItem() : null}
          {selectDataList && selectDataList.length ?
            <div className='result-top-menu-item result-top-menu-setup result-top-menu-select-setup'>
              <span>Signal Group</span>
              <Select
                placeholder={"Model File"}
                value={verificationId}
                onSelect={this.props.changeChannelTab}
                popupClassName='aurora-select-dropdown'
                className='result-top-menu-select'
                options={selectDataList.map(item => ({
                  value: item.id,
                  label: item.name,
                  title: item.name
                }))}
              />
              <span className='aurora-top-bar-vertical-line'></span>
            </div>
            : null}
          <div style={{ width: menuWidth + 150 }} className="result-top-menu-list clear">
            {menuList.map(menuItem => menuItem.key === "subMenu" ?
              <Dropdown menu={{ items: this.subMenu(menuItem.children), onClick: ({ key }) => this.props.changeResultType(key) }} key={menuItem.key + '-item'}>
                <div className='result-top-menu-item'
                  key={menuItem.key + '-item'}
                ><span
                  key={menuItem.key}
                  className={menuItem.children.find(it => it.key === selectedKey) ? "menu-item-title menu-item-title-select" : "menu-item-title"}
                >{menuItem.name}</span>
                </div>
              </Dropdown>
              : (menuItem.key === 'download' ? <div className="result-top-menu-item result-download-content" key={menuItem.key + '-item'}>
                <span className='aurora-top-bar-vertical-line'></span>
                <Button
                  type="primary"
                  ghost
                  onClick={this.handleClick}
                  className="result-export-button">Export xls</Button>
                {(downloadProgress > -1) && <Progress
                  size={{ height: 14 }}
                  strokeColor={'#1890ff'}
                  percent={downloadProgress}
                  className="result-export-progress"
                />}
              </div>
                : menuItem.key === SPLIT_LINE ? <div className='result-top-menu-item' key={menuItem.key + '-item'}>
                  <div className='result-top-menu-item-line' onClick={e => e.preventDefault()}>
                    <span className='rocky-top-bar-vertical-line'></span>
                  </div>
                </div> :
                  <div className='result-top-menu-item'
                    key={menuItem.key + '-item'}
                  >
                    <span
                      key={menuItem.key}
                      className={selectedKey === menuItem.key ? "menu-item-title menu-item-title-select" : "menu-item-title"}
                      onClick={(e) => changeResultType(menuItem.key)}
                    >{menuItem.name}</span>
                  </div>))}
          </div>
          {children}
          {selectedChildren ? selectedChildren() : null}
        </div>
      </TopBox >
    )
  }
}

export default ResultTopMenu;